import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ManagePayoutMethodsBaseComponent } from '@luggagehero/features/shop-manager';
import { IPLookupService, PayoutService, StorageManagerService } from '@luggagehero/services';
import { SharedErrorService } from '@luggagehero/shared/services/error';
import { SharedNotificationService } from '@luggagehero/shared/services/notification';
import { SharedStorageService } from '@luggagehero/shared/services/storage';
import { SharedUserService } from '@luggagehero/shared/services/users';
import { SharedWindowService } from '@luggagehero/shared/services/window';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lh-manage-payout-methods',
  templateUrl: 'manage-payout-methods.component.html',
  styleUrls: ['manage-payout-methods.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManagePayoutMethodsComponent extends ManagePayoutMethodsBaseComponent {
  constructor(
    payoutService: PayoutService,
    storageManagerService: StorageManagerService,
    ipLookupService: IPLookupService,
    userService: SharedUserService,
    window: SharedWindowService,
    notify: SharedNotificationService,
    error: SharedErrorService,
    translate: TranslateService,
    cd: ChangeDetectorRef,
    storageService: SharedStorageService,
  ) {
    super(
      payoutService,
      storageManagerService,
      ipLookupService,
      userService,
      window,
      notify,
      error,
      translate,
      cd,
      storageService,
    );
  }
}
